import React, { useEffect, useState } from 'react';
import client from '../lib/client';
import { logger } from '../lib/helpers';
import { CurrentUserQuery } from '../queries/__generated__/CurrentUserQuery';
import { currentUserQuery } from '../queries/user';
import { User } from './user';

interface UserContext {
  user: User;
  reloadUser: () => void;
}

const UserContext = React.createContext<UserContext>({
  user: User.emptyUser(),
  reloadUser: () => {}
});

const UserProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState(User.emptyUser());
  const [loading, setLoading] = useState(true);

  async function getUser() {
    await client
      .query<CurrentUserQuery>({
        query: currentUserQuery,
        fetchPolicy: 'network-only'
      })
      .then(res => {
        if (res.errors) {
          logger(res.errors);
        }
        if (res.data.me) {
          setUser(new User(res.data.me));
          setLoading(false);
        }
      });
  }

  useEffect(() => {
    getUser();
  }, []);

  async function reloadUser() {
    await getUser();
  }
  if (loading) {
    return <div />;
  }

  return <UserContext.Provider value={{ user, reloadUser }}>{children}</UserContext.Provider>;
};

export { UserContext, UserProvider };
